import React from "react";
import { formatDate } from "../../../utils/ScheduleDateFormat";
import { timeFormat } from "../../../utils/TimeFormat";
import { normalizeTwoWords } from "../../../shared/utils/stringUtilities";
import "./availableHours.scss";
import ButtonSchedule from "../button-schedule/button-schedule";

interface availableHoursInterface {
  date?: string;
  data: any;
  setbuttonActive: any;
  buttonActive: any;
}

const availableHours = (props: availableHoursInterface) => {
  const { date, data, setbuttonActive, buttonActive } = props;

  return (
    <div className="a-availbleContainer">
      <div className="a-availbleContainer__title">
        <span>Horario disponible</span>
      </div>
      <div className="a-availbleContainer__date">
        <span>{date ? formatDate(date) : ""}</span>
      </div>
      <div className="a-availbleContainer__hours">
        {data ? (
          data.map((el, index) => (
            <ButtonSchedule
              key={`btn${index}`}
              name={timeFormat(el)}
              active={buttonActive === timeFormat(el)}
              setbuttonActive={setbuttonActive}
              schedule={true}
              gtm={`gtmRedDeAmorSesionIniciadaAgendarServicioFechaHoraHorarioDisponible${normalizeTwoWords(
                timeFormat(el)
              )}`}
            />
          ))
        ) : (
          <span>Seleccione un dia con Horario Disponible</span>
        )}
      </div>
    </div>
  );
};

export default availableHours;
